import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SlugExistsError extends CodedError {
  static get errorName() {
    return errorCodes.slugExistsError.code;
  }

  constructor(message: string = errorCodes.slugExistsError.message) {
    super(message);
    this.code = errorCodes.slugExistsError.code;
    this.message = `${message} ${errorCodes.slugExistsError.code}`;
    this.name = errorCodes.slugExistsError.name;
  }
}
